module.exports = __webpack_public_path__ + "img/logo-RMZ-Asesores-blanco.0f1b913a.svg";